import { InstagramLogo, TiktokLogo, PinterestLogo } from "@phosphor-icons/react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0a0705] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center">
              <img
                src="/logo-wordmark.png"
                alt="Kim Monroe LLC"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="mt-5 text-sm text-[#A39791] font-body leading-relaxed max-w-md">
              Premium retail wigs and hair, hand-crafted in America. A study in
              quiet luxury, atelier-made for the modern woman.
            </p>
            <div className="flex items-center gap-3 mt-8">
              {[
                { Icon: InstagramLogo, label: "instagram" },
                { Icon: TiktokLogo, label: "tiktok" },
                { Icon: PinterestLogo, label: "pinterest" },
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href="#"
                  data-testid={`social-${label}`}
                  aria-label={label}
                  className="w-11 h-11 border border-white/10 flex items-center justify-center text-[#A39791] hover:border-[#E6CC98] hover:text-[#E6CC98] transition-all duration-500"
                >
                  <Icon size={18} weight="thin" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] gold-text font-body mb-5">
              Shop
            </div>
            <ul className="space-y-3 text-sm font-body text-[#A39791]">
              <li><a href="#collection" className="hover:text-[#FDFBF7] transition-colors">Wigs</a></li>
              <li><a href="#collection" className="hover:text-[#FDFBF7] transition-colors">Bundles</a></li>
              <li><a href="#collection" className="hover:text-[#FDFBF7] transition-colors">Lace</a></li>
              <li><a href="#collection" className="hover:text-[#FDFBF7] transition-colors">Closures</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] gold-text font-body mb-5">
              House
            </div>
            <ul className="space-y-3 text-sm font-body text-[#A39791]">
              <li><a href="#heritage" className="hover:text-[#FDFBF7] transition-colors">Heritage</a></li>
              <li><a href="#story" className="hover:text-[#FDFBF7] transition-colors">Founder</a></li>
              <li><a href="#waitlist" className="hover:text-[#FDFBF7] transition-colors">Waitlist</a></li>
              <li><a href="#" className="hover:text-[#FDFBF7] transition-colors">Press</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] gold-text font-body mb-5">
              Atelier
            </div>
            <p className="text-sm font-body text-[#A39791] leading-relaxed">
              Studio visits by appointment.
              <br />
              <span className="text-[#FDFBF7]">hello@kimmonroellc.com</span>
              <br />
              Atlanta · Houston · Los Angeles
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[#A39791]/70 font-body uppercase tracking-[0.25em]">
            © {new Date().getFullYear()} Kim Monroe LLC · Made in America
          </p>
          <div className="flex items-center gap-6 text-xs text-[#A39791]/70 font-body uppercase tracking-[0.25em]">
            <a href="#" className="hover:text-[#FDFBF7]">Privacy</a>
            <a href="#" className="hover:text-[#FDFBF7]">Terms</a>
            <a href="#" className="hover:text-[#FDFBF7]">Care Guide</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
